export const sidePanelStyles = {
  root: "flex h-full flex-col border-l border-panel-border bg-panel",
  header: "flex shrink-0 items-center justify-between bg-panel-surface px-4 py-3",
  headerBrand: "flex items-center gap-2",
  headerAvatar: "h-8 w-8",
  headerTitle: "text-sm font-semibold text-strong",
  headerVersion: "self-end pb-px text-3xs text-subtle",
  headerActions: "flex items-center gap-1",
  headerBtn:
    "flex h-7 w-7 items-center justify-center rounded-full text-subtle transition-colors hover:bg-panel-hover hover:text-mid",
  tabBar: "flex items-center border-b border-panel-border bg-panel-surface px-4",
  tabTrigger:
    "-mb-px h-auto flex-none rounded-none border-0 border-b-2 border-transparent px-0 py-2.5 text-xs font-medium text-subtle transition-colors after:hidden hover:text-mid data-[state=active]:border-active data-[state=active]:text-primary",
  chatTabTrigger: "mr-5",
  newChatBtn:
    "mb-px flex h-7 w-7 items-center justify-center rounded-full text-active transition-colors hover:bg-panel-hover hover:text-primary-dark",
  content: "flex min-h-0 flex-1 flex-col overflow-hidden",
  alertList: "flex shrink-0 flex-col gap-2 pt-3",
  messages: "flex flex-col gap-5 px-4 py-4 empty:hidden",
  disclaimer: "flex items-center gap-3 text-2xs text-subtle",
  disclaimerRule: "h-px flex-1 bg-dim",
  threadFooter: "sticky bottom-0 z-10 mt-auto",
};
